import { fmt } from "@nabble/ui";
import type { DataRequestKind } from "../../../../api/dataRequests";
import { DETAILS_MAX, detailsRequired } from "../../../../model/dataRequests";

/** What's wrong with the details typed for a request of `kind`, or `undefined` when they can be sent. */
export function detailsProblem(kind: DataRequestKind, text: string): string | undefined {
  if (detailsRequired(kind) && !text) return "Tell us what is wrong and what it should say.";
  if (text.length > DETAILS_MAX) return `Keep it under ${fmt.number(DETAILS_MAX)} characters.`;
  return undefined;
}
